import api from '../../agent'
import create from './base'

export interface AccountState {
    value: number;
    errors: [];
    user: any;
    token: string | null;
}

// Helper function to save token to localStorage
const saveTokenToLocalStorage = (token: string | null) => {
    if (token) {
        localStorage.setItem('authToken', token);
    } else {
        localStorage.removeItem('authToken');
    }
}

// Helper function to load token from localStorage
const loadTokenFromLocalStorage = (): string | null => {
    return localStorage.getItem('authToken');
}

const initialState: AccountState = {
    value: 0,
    errors: [],
    user: null,
    token: loadTokenFromLocalStorage(),
}

const AccountRedux = create('account', initialState, {
    increment: (state: AccountState) => {
        state.value += 1
    },
}, {
    register: async (state: AccountState, params: any = {}) => {
        const response = await api.register(params)

        if (!response.success) {
            return {
                ...state,
                errors: [response.message]
            }
        }

        return {
            user: response.data
        }
    },
    login: async (state: AccountState, params: any = {}) => {
        const response = await api.login(params)

        if (response.statusCode === 401) {
            return {
                ...state,
                errors: ['Invalid email or password']
            }
        }

        if (!response.success) {
            return {
                errors: [response.message]
            }
        }

        saveTokenToLocalStorage(response.data.token);

        return {
            token: response.data.token,
            user: response.data.user
        }
    },
    getAuthUser: async (state: AccountState, params: any = {}) => {
        const response = await api.getAuthUser(params.token)

        return {
            user: response
        }
    },
    clearErrors: async (state: AccountState) => {
        return {
            errors: []
        }
    },
    logout: async (state: AccountState) => {
        localStorage.removeItem('authToken')

        return {
            token: null
        }
    }
})

export const {
    increment,
    register,
    login,
    getAuthUser,
    clearErrors,
    logout
} = AccountRedux.actions

export default AccountRedux.reducer
